import { useNavigate } from 'react-router-dom';
import { LessonSubjectsTable } from '../../../../components/Lessons/Tables/Subjects/LessonSubjectsTable';
import { Page } from '../../../../components/Page/Page';
import { usePermissionChecker } from '../../../../hooks/usePermissionChecker';

export const LessonSubjectsSubpage = () => {
  const navigate = useNavigate();
  const permissions = usePermissionChecker();

  function handleNavigate(classUuid: string) {
    navigate(classUuid);
  }

  return (
    <Page isForbidden={!permissions?.canReadDeputate()}>
      <LessonSubjectsTable onNavigate={handleNavigate} />
    </Page>
  );
};
